module.exports = __webpack_public_path__ + "static/media/eaglesLogo-big.2ad6cb8e.png";